module.exports = "/static/assets/0b8b6b69c311fff2fba742b6c323fbe6.png";